<template lang="html">
    <div class="account-settings">
        <Heading :title="$t('account_container_my_account')" :just-title="true" :class="'mb-4'" :routeName="'vignette'" :showLogout="true" :alignment="'text-center'"></Heading>
        <div class="container container-small">
            <div class="tabs" ref="tabs">
                <div class="tabs-wrapper d-flex remove-a">
                    <router-link :to="{name: 'my-cars'}" class="checkout-tab-button text-center">
                        <i class="vehicles-icon"></i>
                        <p>{{ $t('account_container_vehicles') }}</p>
                    </router-link>
                    <router-link :to="{name: 'my-orders'}" class="checkout-tab-button text-center">
                        <i class="orders-icon"></i>
                        <p>{{ $t('account_container_orders') }}</p>
                    </router-link>
                    <router-link :to="{name: 'profiles'}" class="checkout-tab-button text-center">
                        <i class="profiles-icon"></i>
                        <p>{{ $t('account_container_profiles') }}</p>
                    </router-link>
                    <router-link :to="{name: 'cards'}" class="checkout-tab-button text-center">
                        <i class="fal fa-credit-card"></i>
                        <p>{{ $t('account_container_cards') }}</p>
                    </router-link>
                    <router-link :to="{name: 'account-data'}" class="checkout-tab-button text-center">
                        <i class="account-icon"></i>
                        <p>{{ $t('account_container_info') }}</p>
                    </router-link>
                </div>
            </div>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'

export default {
    name: '',
    components: {
        Heading
    },
    props: {},
    mounted() {
        setTimeout(() => {
            this.scrollToActiveTab();
        }, 300);
    },
    methods: {
        scrollToActiveTab() {
            this.$refs.tabs.getElementsByClassName('router-link-exact-active')[0].scrollIntoView({
                behaviour: "smooth",
                block: "end"
            });
        }
    }
}
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;

.account-settings {

    @media only screen and (max-width: 768px) {
        margin-top: 42px;
    }

    @media only screen and (min-width: 769px) {
        margin-top: 53px;
    }
}

.tabs {
    border-bottom: 1px solid #C7C7C6;
    margin-top: 33px;

    @media only screen and (max-width: 768px) {
        margin: 0px -18px;

        .tabs-wrapper {
            overflow-x: auto;
            padding: 0px 18px;
        }
    }

    .tabs-wrapper {

        p {
            &:hover {
                text-decoration: underline;
                color: #737880;
            }
        }
    }
}

.checkout-tab-button {
     padding: 7px 5px 5px 5px;
     display: block;
     display: flex;
     flex-grow: 1;
     justify-content: center;

     @media only screen and (max-width: 768px) {
         margin-right: 20px;
     }

     i {
          margin-right: 9px;
          font-size: 20px;
     }

     p {
        font-weight: bold;
        margin-bottom: 0px;

        @media only screen and (max-width: 768px) {
            white-space: nowrap;
        }
     }
}

.router-link-exact-active {
    border-bottom-color: #0F2443;
    border-bottom-width: 6px;
    border-bottom-style: solid;
}
</style>
